/**
 * Theme utilities for Modern Dashboard components
 * Provides consistent color schemes for dark and light modes
 */

export const getThemeColors = (themeMode = 'dark') => {
	const isDark = themeMode === 'dark';

	return {
		// Background colors
		background: {
			primary: isDark ? '#0f172a' : '#f1f5f9',
			secondary: isDark ? '#1e293b' : '#ffffff',
			tertiary: isDark ? '#334155' : '#f8fafc'
		},
		
		// Border colors
		border: {
			primary: isDark ? '#334155' : '#e2e8f0',
			secondary: isDark ? '#475569' : '#cbd5e1',
			hover: isDark ? '#475569' : '#94a3b8'
		},
		
		// Text colors
		text: {
			primary: isDark ? '#f8fafc' : '#0f172a',
			secondary: isDark ? '#cbd5e1' : '#475569',
			tertiary: isDark ? '#94a3b8' : '#64748b',
			muted: isDark ? '#64748b' : '#94a3b8'
		},
		
		// Accent colors (consistent across themes)
		accent: {
			blue: '#1C75D2',
			green: '#22c55e',
			red: '#ef4444',
			yellow: '#f59e0b',
			purple: '#a855f7'
		},
		
		// Status colors
		status: {
			active: isDark ? '#22c55e' : '#16a34a',
			inactive: isDark ? '#94a3b8' : '#64748b',
			error: isDark ? '#ef4444' : '#dc2626',
			warning: isDark ? '#f59e0b' : '#d97706',
			info: isDark ? '#3b82f6' : '#2563eb'
		},
		
		// Map colors
		map: {
			background: isDark ? '#1e293b' : '#ffffff',
			landFill: isDark ? '#2d3748' : '#e2e8f0',
			landStroke: isDark ? '#4a5568' : '#cbd5e1',
			ocean: isDark ? '#0f172a' : '#cfe9faff',
			active: isDark ? '#1C75D2' : '#1C75D2',
			inactive: isDark ? '#94a3b8' : '#94a3b8',
			error: isDark ? '#ef4444' : '#ef4444'
		},
		
		// Card styles
		card: {
			background: isDark ? '#1e293b' : '#ffffff',
			border: isDark ? '#334155' : '#e2e8f0',
			hoverBorder: isDark ? '#475569' : '#cbd5e1',
			shadow: isDark ? 'none' : '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
			hoverShadow: isDark ? 'none' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
			footerBg: isDark ? 'rgba(15, 23, 42, 0.5)' : '#f8fafc'
		},
		
		// Badge/Chip colors
		badge: {
			activeBg: isDark ? 'rgba(34, 197, 94, 0.1)' : 'rgba(22, 163, 74, 0.1)',
			activeText: isDark ? '#22c55e' : '#16a34a',
			inactiveBg: isDark ? 'rgba(148, 163, 184, 0.1)' : 'rgba(100, 116, 139, 0.1)',
			inactiveText: isDark ? '#94a3b8' : '#64748b',
			totalBg: isDark ? 'rgba(59, 130, 246, 0.2)' : 'rgba(37, 99, 235, 0.1)',
			totalText: isDark ? '#3b82f6' : '#2563eb'
		}
	};
};

/**
 * Get conditional class based on theme mode
 */
export const getThemeClass = (themeMode, darkClass, lightClass) => {
	return themeMode === 'dark' ? darkClass : lightClass;
};
